<template>
	<b-container>

		<b-form @submit.prevent="createCustomer">

			<b-row class="mt-3">

				<b-col>
					<h1>Create new customer</h1>
				</b-col>

				<b-col>

					<b-link
						:to="{ name: 'customers' }"
						title="Cancel"
						class="float-right  ml-3  btn  btn-link"
					>
						<b-icon
							font-scale="1.5"
							icon="trash"
                            variant="danger"
						></b-icon>
					</b-link>

					<b-button
						variant="link"
						type="submit"
						title="Save new customer"
						class="float-right  ml-3"
					>
						<b-icon
							font-scale="1.5"
							icon="check-square"
                            variant="success"
						></b-icon>
						</b-button>
				</b-col>

			</b-row>

			<b-row class="mt-3">
				<b-col cols="6">

					<b-form-group
						breakpoint="md"
						horizontal
					>
						<b-form-input
							id="name"
							placeholder="Customer Name"
							v-model="customer.Name"
							maxlength="60"
							required
						/>
					</b-form-group>
				</b-col>
			</b-row>

		</b-form>

		<b-modal
			ref="alertModal"
			:title="alertModalTitle"
			:ok-only="true"
			@ok="onAlertModalOkClick"
		>
			<p class="my-4">{{ alertModalContent }}</p>
		</b-modal>

	</b-container>
</template>

<script>
import CustomerService from "@/api-services/customer.service";

export default {
	name: "CustomerCreate",

	data() {
		return {
			customer: {
				Clocks: [],
				Contacts: [],
				InvoiceContact: {},
				ServiceContracts: [],
			},

			alertModalTitle: "",
			alertModalContent: "",
			isSuccess: false,
		};
	},

	methods: {
		createCustomer() {
			CustomerService.create(this.customer)
				.then((res) => {
					this.customer.Id = res.data.Id;
					this.saveAndContinue();
				})
				.catch((error) => {
					this.isSuccess = false;
					this.alertModalTitle = "Error";
					this.alertModalContent = error.response.data;
					this.$refs.alertModal.show();
				});
		},

		onAlertModalOkClick() {
			if (this.isSuccess) {
				this.$router.push({ name: "customers" });
			}
		},

		saveAndContinue() {
			this.$router.push({
				name: "customerupdate",
				params: { id: this.customer.Id },
			});
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/customer/customer-create.vue